import { render, staticRenderFns } from "./CriteriaSave.vue?vue&type=template&id=0998b7d5&"
import script from "./CriteriaSave.vue?vue&type=script&lang=js&"
export * from "./CriteriaSave.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaSave.vue?vue&type=style&index=0&id=0998b7d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports